import MenuList from '@frontend/features/navigation/components/menu/MenuList'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'

function ProjectMegaMenu() {
  const { settings } = useSiteConfiguration()

  if (!settings?.megaMenus.projects) {
    return <></>
  }

  const { asava, asv, collaboration } = settings.megaMenus.projects

  return (
    <div className="mx-auto max-w-screen-lg md:px-7 md:py-6">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-3">
        <div>
          <MenuList items={asava.items} title={asava.title} />
        </div>
        <div>
          <MenuList items={asv.items} title={asv.title} />
        </div>
        <div>
          <MenuList items={collaboration.items} title={collaboration.title} />
        </div>
      </div>
    </div>
  )
}

export default ProjectMegaMenu
